export default __webpack_public_path__ + "static/media/ovalsBlurred.412720b8.png";